import { Component, Input, ChangeDetectionStrategy, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Platform } from 'ionic-angular';
import { User } from '../../providers/user/user';

/**
 * Generated class for the VideoIframeComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */

declare function unescape(s:string): string;
@Component({
  selector: 'video-iframe',
  templateUrl: 'video-iframe.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VideoIframeComponent implements OnInit {

  @Input() video: string;

  youTubeLink: any;
  zoomLink: any;
  daCastLink: any;
  streamSharkLink: any;
  joinZoom = false;

  constructor(public sanitizer: DomSanitizer, public platform: Platform, private user: User) {
    console.log('Hello YoutubeIframeComponent Component');
  }

  ngOnInit() {
    this.showVideoUrl(this.video);
  }

  showVideoUrl(url: string) {
    if (url) {
      const matchUrl = url.match("v=([a-zA-Z0-9\_\-]+)&?") || url.match("https://youtu.be/([a-zA-Z0-9\_\-]+)&?");
      console.log('MATCHURL', matchUrl)
      const code = matchUrl ? matchUrl[1] : '';
      if (code) {
        let dangerousVideoUrl = 'https://www.youtube.com/embed/' + code;
        this.youTubeLink = this.sanitizer.bypassSecurityTrustResourceUrl(dangerousVideoUrl);
      } else if (url.includes('https://zoom.us/wc/')) {
        const { firstName, lastName } = this.user.currentUser();
        console.log('USER', firstName + ' ' + lastName)
        let dangerousVideoUrl = url + '/join?prefer=1&un=' + btoa(unescape(encodeURIComponent(firstName + ' ' + lastName)));
        this.zoomLink = this.sanitizer.bypassSecurityTrustResourceUrl(dangerousVideoUrl);
      } else if (url.includes('https://iframe.dacast.com')) {
        this.daCastLink = this.sanitizer.bypassSecurityTrustResourceUrl(url);
      } else if (url.includes('https://play.streamshark.io')) {
        this.streamSharkLink = this.sanitizer.bypassSecurityTrustResourceUrl(url);
      }
    }
  }

  isIOS() {
    return (this.platform.is('cordova') && this.platform.is('ios'));
  }

}



// WEBPACK FOOTER //
// ./src/components/video-iframe/video-iframe.ts